import LastViewedVehicles from '../../../../common/storage/autoV10/LastViewedVehicles';
import SearchQuery from '../../../../common/storage/autoV10/SearchQuery.js';
import EnquiriesSent from '../../../../common/storage/autoV10/EnquiriesSent.js';
import Base from './Base';

export default class V10DataProvider extends Base {
  static get lastViewedVehicles() {
    return LastViewedVehicles.getNumbers();
  }

  static get hasSearched() {
    return SearchQuery.get();
  }

  static get sentEnquiries() {
    return EnquiriesSent.get();
  }

  static set lastViewedVehicles(value) {
    LastViewedVehicles.set(value);
  }

  static set hasSearched(value) {
    SearchQuery.set(value);
  }

  static set sentEnquiries(value) {
    EnquiriesSent.set(value);
  }
}
